import { SplitText } from "../vendor/SplitText.min";
var Flickity = require('flickity');
export const home = {
  init: function () {

    var imageRevealTxt = new SplitText(".image-reveal-txt", {
      type: "words,lines",
    });

    // Function to resize the image reveal to adapt to all aspect ratios
    function resize(vid) {
      const ratio = 1.5;
      const w = vid.innerWidth();
      const h = vid.innerHeight();      
      const scale = w / h > ratio ? 1 : (h * ratio) / w;
      return (scale * 120);
    }

    let mm = gsap.matchMedia();

    mm.add("(max-width: 768px)", () => {

      if($('body').hasClass('home')) {
        ScrollTrigger.create({
          trigger: ".bk-circle-reveal",
          id: "Circle",
          start: "top 0px",
          end: () => $(".bk-circle-reveal").outerHeight() * 2.5,
          scrub: true,
          pin: true,
          pinSpacing: true,
          //markers: {startColor:"DarkCyan", endColor:"CornflowerBlue", fontSize:"16px", indent: 0}
        });
      } 
      // else {
      //   ScrollTrigger.create({
      //     trigger: ".bk-circle-reveal",
      //     id: "Circle",
      //     start: "top 0",
      //     end: () => $(".bk-circle-reveal").outerHeight() * 2.5,
      //     pin: true,
      //     pinSpacing: true,
      //     scrub: true,
      //     //markers: {startColor:"DarkCyan", endColor:"CornflowerBlue", fontSize:"16px", indent: 0}
      //   });
      // }

      if($('body').hasClass('home')) {
        gsap.set(".image-reveal", { backgroundSize: "45%", backgroundPosition: "50%", "--clip": "35%" });
        var imageReveal = gsap
        .timeline({ defaults: { ease: "power1.inOut" } })
        .to(".image-reveal", { top: "0" })
        .from(imageRevealTxt.lines, {
          x: 100,
          autoAlpha: 0,
          ease: "power3",
          stagger: 0.2,
        })
        .to(
          ".image-reveal",
          { backgroundSize: `${resize($(window))}%` },
          0.2
        )
        .to(".image-reveal", { "--clip": "100%" }, 0.2)

        ScrollTrigger.create({
          trigger: ".bk-circle-reveal",
          id: "Image Reveal",
          start: "top 200px",
          end: () => $(".bk-circle-reveal").outerHeight() * 2.5,
          animation: imageReveal,
          scrub: true,
          //markers: {startColor:"Crimson", endColor:"DarkMagenta", fontSize:"16px", indent: 130}
        });       
      } 
      // else {
      //   gsap.set(".image-reveal", { backgroundSize: "45%", backgroundPosition: "50%", "--clip": "35%" });
      //   var imageReveal = gsap
      //   .timeline({ defaults: { ease: "power1.inOut" } })
      //   .to(".image-reveal", { top: "0" })
      //   .from(imageRevealTxt.lines, {
      //     x: 100,
      //     autoAlpha: 0,
      //     ease: "power3",
      //     stagger: 0.2,
      //   })
      //   .to(
      //     ".image-reveal",
      //     { backgroundSize: `${resize($(window))}%` },
      //     0.2
      //   )
      //   .to(".image-reveal", { "--clip": "100%" }, 0.2)

      //   ScrollTrigger.create({
      //     trigger: ".bk-circle-reveal",
      //     id: "Image Reveal",
      //     start: "top 300px",
      //     end: () => $(".bk-circle-reveal").outerHeight() * 2.5,
      //     animation: imageReveal,
      //     scrub: true, 
      //     //markers: {startColor:"Crimson", endColor:"DarkMagenta", fontSize:"16px", indent: 130}
      //   });
      // }   
    })
    mm.add("(min-width: 769px)", () => {
      if($('body').hasClass('home')) {
        ScrollTrigger.create({
          trigger: ".bk-circle-reveal",
          id: "Circle",
          start: "top 0px",
          end: () => $(".bk-circle-reveal").outerHeight() * 2.5,
          scrub: true,
          pin: true,
          pinSpacing: true,
          //markers: {startColor:"DarkCyan", endColor:"CornflowerBlue", fontSize:"16px", indent: 0}
        });
      } 
      // else {
      //   ScrollTrigger.create({
      //     trigger: ".bk-circle-reveal",
      //     id: "Circle",
      //     start: "top 0px",
      //     end: () => $(".bk-circle-reveal").outerHeight() * 2,
      //     scrub: true,
      //     pin: true,
      //     pinSpacing: true,
      //     //markers: {startColor:"DarkCyan", endColor:"CornflowerBlue", fontSize:"16px", indent: 0}
      //   });
      // }
      if($('body').hasClass('home')) {
        var animaPos = $('body').hasClass('home') ? '100% center' : '50% center';
        gsap.set(".image-reveal", { backgroundSize: "45%", backgroundPosition: "50%", "--clip": "13%" });
        var imageReveal = gsap
          .timeline({ defaults: { ease: "power1.inOut" } })
          .to(".image-reveal", { top: "0" })
          .from(imageRevealTxt.lines, {
            x: 100,
            autoAlpha: 0,
            ease: "power3",
            stagger: 0.2,
          })
          .to(".image-reveal", { backgroundSize: `${resize($(window))}%` }, 0.2)
          .to(".image-reveal", { "--clip": "100%" }, 0.2)
          .to(".image-reveal", { backgroundPosition: animaPos }, 0.4);
  
        ScrollTrigger.create({
          trigger: ".bk-circle-reveal",
          id: "Image Reveal",
          start: "top 200px",
          end: () => $(".bk-circle-reveal").outerHeight() * 2.5,
          animation: imageReveal,
          scrub: true,
          //markers: {startColor:"Crimson", endColor:"DarkMagenta", fontSize:"16px", indent: 130}
        });
      } 
      // else {
      //   var animaPos = $('body').hasClass('home') ? '100% center' : '50% center';
      //   gsap.set(".image-reveal", { backgroundSize: "45%", backgroundPosition: "50%", "--clip": "13%" });
      //   var imageReveal = gsap
      //     .timeline({ defaults: { ease: "power1.inOut" } })
      //     .to(".image-reveal", { top: "0" })
      //     .from(imageRevealTxt.lines, {
      //       x: 100,
      //       autoAlpha: 0,
      //       ease: "power3",
      //       stagger: 0.1,
      //     })
      //     .to(".image-reveal", { backgroundSize: `${resize($(window))}%` }, 0.1)
      //     .to(".image-reveal", { "--clip": "100%" }, 0.1)
      //     .to(".image-reveal", { backgroundPosition: animaPos }, 0.1);

      //   ScrollTrigger.create({
      //     trigger: ".bk-circle-reveal",
      //     id: "Image Reveal",
      //     start: "top 50%",
      //     end: () => $(".bk-circle-reveal").outerHeight() * 2.5,
      //     animation: imageReveal,
      //     scrub: true,
      //     //markers: {startColor:"Crimson", endColor:"DarkMagenta", fontSize:"16px", indent: 130}
      //   });      
      // }  
    })
  
    /*********** */
    gsap.fromTo(
      ".trait-presentation .first", { x:"-60vw", },
      {
        x:"0",
        scrollTrigger: {
          trigger: ".trait-presentation",
          start: "top 100%",
          end: "top 10%",
          scrub: true,
    
        }
      }
    );
    gsap.fromTo(
      ".trait-presentation .second", { x:"60vw", },
      {
        x:"80px",
        scrollTrigger: {
          trigger: ".trait-presentation",
          start: "top 100%",
          end: "top 10%",
          scrub: true,
    
        }
      }
    );
    setTimeout(function() { 

      function setupSplits() {
        const targets = gsap.utils.toArray(".splittedtitle");
        targets.forEach((target) => {
          let SplitClient = new SplitText(target, { type: "words,lines",linesClass: "split-child" });
          let chars = SplitClient.words; //an array of all the divs that wrap each character
          gsap.from(chars, {
            duration: 1.5,
              y: 180,
              ease: "power4.inOut",
              //  stagger: 0.011,
            
              
              scrollTrigger: {
                trigger: target,
                // markers: true,
                start: 'top 90%',
            }
          });
        });
      }
      
      setupSplits();
    }, 500);
    const titles = gsap.utils.toArray(".long-text, .description, .traitement-cat-rows .traitement-cat-link, .product-card, .article-recent .wp-block-post-template li, .container-article .wp-block-post, .bk-before-after--tabs, .wp-block-pb-accordion-item, .bk-advantages ul li");

    titles.forEach((text, i) => {
      gsap.fromTo(
        text,
        { y: 30, opacity: 0 },
        {
          y: 0,
          opacity: 1,
         
          scrollTrigger: {
            trigger: text,
            toggleActions: "play",
            start: "top 80%",
            end: "bottom ",
            stagger: 1,
          },
        }
      );
    });
    // if($('.testi-carousel').length) {
    //   var testiCarouselFlky = new Flickity( '.testi-carousel', {
    //     autoPlay: 4000,     
    //     prevNextButtons: false,
    //     wrapAround: true,
    //     imagesLoaded: true,
    //     pageDots: true,
    //   });
    // }

    gsap.fromTo(
      ".home-hero p", { opacity: 0, },
      {
        opacity: 1,
        duration: 1,
        delay:1,
      }
    );
    gsap.fromTo(
      ".home-hero p:nth-child(2)", {  },
      {
       x:50,
       delay:1.5,
      }
    );

  }
};
